import { render, staticRenderFns } from "./PT115TokuProductListParts.vue?vue&type=template&id=28c20004&"
import script from "./PT115TokuProductListParts.vue?vue&type=script&lang=js&"
export * from "./PT115TokuProductListParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports